export default __webpack_public_path__ + "static/media/icon_maintenance.73a15857.svg";